module.exports = __webpack_public_path__ + "img/home-02.51895f15.jpg";